var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingP2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 350.003,
  height: 333.327,
  viewBox: "0 0 350.003 333.327"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "parking_P2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 249.995h262.502V0H0z"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0072ce",
  d: "m0 0 .007 333.327h349.996V0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#parking_P2_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 333.327)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M197.05 40.736V26.182h-61.384v15.48c8.6 8.335 39.95 34.52 39.95 51.462 0 8.463-7.54 12.433-15.084 12.433-7.8 0-15.207-3.443-21.295-7.412l-1.456 15.346c8.335 4.233 17.993 6.617 27.39 6.617 17.59 0 28.965-8.863 28.965-26.982 0-19.58-19.71-37.577-34.79-52.388zM94.016 157.17H84.37v41.958h9.646c14.185 0 26.203-5.513 26.203-21.473 0-15.953-12.41-20.484-26.205-20.484m54.962 22.063c0 32.9-27.38 41.568-57.325 41.568H56.788V83.305h27.58V135.5h11.617c29.548 0 52.993 11.624 52.993 43.732"
}))));
export default SvgParkingP2;